(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sw-delivery-options"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__swDelivery) return; window.__swDelivery = true;
    var chosen = null; // 'subscribe' | '' | null
    var money = function (cents) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2); };
    function root() { return document.querySelector('[data-sw-do]'); }
    function form(el) { var s = el && el.closest('.shopify-section'); return (s || document).querySelector('product-form-component form') || document.querySelector('product-form-component form'); }
    function sync() {
      var r = root(); if (!r) return; var f = form(r); if (!f) return;
      var radios = r.querySelectorAll('input[name="sw_delivery"]');
      if (chosen !== null) radios.forEach(function (x) { x.checked = x.value === chosen; });
      var sub = r.querySelector('input[name="sw_delivery"][value="subscribe"]');
      var sel = r.querySelector('[data-sw-plan-select]');
      var val = (sub && sub.checked && sel) ? sel.value : '';
      var mirror = f.querySelector('input[name="selling_plan"][data-sw-mirror]');
      if (val) { if (!mirror) { mirror = document.createElement('input'); mirror.type = 'hidden'; mirror.name = 'selling_plan'; mirror.setAttribute('data-sw-mirror', ''); f.appendChild(mirror); } mirror.value = val; }
      else if (mirror) mirror.remove();
      r.querySelectorAll('.sw-do__card').forEach(function (c) { c.classList.toggle('is-active', !!c.querySelector('input:checked')); });
      // price readouts for the selected cadence
      if (sel) { var opt = sel.options[sel.selectedIndex]; var p = Number(opt && opt.getAttribute('data-price')); if (p) { var sp = r.querySelector('[data-sw-sub-price]'); if (sp) sp.textContent = money(p); var pl = r.querySelector('[data-sw-per-load]'); if (pl) pl.textContent = money(Math.round(p / (Number(r.getAttribute('data-sw-pods')) || 30))); } }
      // add-to-cart wording
      var btnText = (f.closest('product-form-component') || f).querySelector('.add-to-cart-text__content');
      if (btnText) btnText.textContent = val ? r.getAttribute('data-sub-label') : r.getAttribute('data-once-label');
    }
    document.addEventListener('change', function (e) {
      var t = e.target; if (!t || !t.closest || !t.closest('[data-sw-do]')) return;
      if (t.name === 'sw_delivery') chosen = t.value;
      sync();
    });
    document.addEventListener('submit', function (e) { if (e.target && e.target.closest && e.target.closest('product-form-component')) sync(); }, true);
    // Horizon only morphs its own blocks on variant change; swap this block for the fresh one from the fetched document.
    document.addEventListener('variant:update', function (e) {
      var r = root(); var h = e.detail && e.detail.data && e.detail.data.html; var n = h && h.querySelector ? h.querySelector('[data-sw-do]') : null;
      if (r && n) {
        var sel = r.querySelector('[data-sw-plan-select]'); var planId = sel ? sel.value : null;
        var fresh = n.cloneNode(true); r.replaceWith(fresh);
        if (planId) { var ns = fresh.querySelector('[data-sw-plan-select]'); if (ns && Array.prototype.some.call(ns.options, function (o) { return o.value === planId; })) ns.value = planId; }
      }
      setTimeout(sync, 0); setTimeout(sync, 300);
    });
    document.addEventListener('variant:selected', function () { setTimeout(sync, 0); setTimeout(sync, 300); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sw-purchase-options"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__swPurchaseOptions) return;
    window.__swPurchaseOptions = true;
    var chosen = null;
    function productForm(fieldset) {
      var section = fieldset ? fieldset.closest('.shopify-section') : null;
      var scope = section || document;
      return scope.querySelector('product-form-component form') || document.querySelector('product-form-component form');
    }
    function sync() {
      var fieldset = document.querySelector('[data-sw-po]');
      var form = productForm(fieldset);
      if (!form) return;
      var radios = fieldset ? fieldset.querySelectorAll('input[name="sw_selling_plan"]') : [];
      if (chosen !== null && radios.length) {
        var found = false;
        radios.forEach(function (r) { r.checked = r.value === chosen; if (r.checked) found = true; });
        if (!found && radios[0]) radios[0].checked = true;
      }
      var val = '';
      radios.forEach(function (r) { if (r.checked) val = r.value; });
      var mirror = form.querySelector('input[name="selling_plan"][data-sw-mirror]');
      if (val) {
        if (!mirror) {
          mirror = document.createElement('input');
          mirror.type = 'hidden';
          mirror.name = 'selling_plan';
          mirror.setAttribute('data-sw-mirror', '');
          form.appendChild(mirror);
        }
        mirror.value = val;
      } else if (mirror) {
        mirror.remove();
      }
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-sw-po] input[name="sw_selling_plan"]')) { chosen = t.value; sync(); }
    });
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.closest && e.target.closest('product-form-component')) sync();
    }, true);
    ['variant:update', 'variant:selected'].forEach(function (n) {
      document.addEventListener(n, function () { setTimeout(sync, 0); setTimeout(sync, 250); });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sw-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sw-tabs] [role="tab"]'); if (!b) return;
    var root = b.closest('[data-sw-tabs]');
    root.querySelectorAll('[role="tab"]').forEach(function (t) { var on = t === b; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
    root.querySelectorAll('[role="tabpanel"]').forEach(function (p) { p.hidden = p.id !== b.getAttribute('aria-controls'); });
  });
  } catch(e) { console.error(e); }
})();

})();
